import { CalendarDays, ChevronRight } from "lucide-react";

export default function TealWaveCTA() {
  return (
    <section
      aria-label="Book a meeting with SympTrack"
      data-testid="teal-wave-section"
    >
      <svg
        className="block h-[64px] w-full md:h-[96px]"
        viewBox="0 0 1440 100"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <path
          d="M0,34 C240,2 520,66 820,82 C1090,96 1290,84 1440,42 L1440,100 L0,100 Z"
          fill="#075866"
        />
      </svg>
      <div className="relative overflow-hidden bg-brand-teal">
        <div aria-hidden="true" className="pointer-events-none absolute inset-0">
          <div className="absolute -left-16 bottom-[-70px] h-[210px] w-[210px] rounded-full border border-dashed border-white/25" />
          <div className="absolute -right-20 top-1/2 h-[240px] w-[240px] -translate-y-1/2 rounded-full border border-white/10" />
          <div className="absolute bottom-[-40px] right-[12%] h-[90px] w-[90px] rounded-full bg-brand-coral/25" />
        </div>
        <div
          className="symp-container relative flex flex-col items-center gap-8 pb-14 pt-4 text-center md:flex-row md:justify-between md:gap-10 md:pb-16 md:text-left"
          data-testid="wave-content"
        >
          <div
            className="rounded-[20px] bg-brand-cream px-5 py-3 shadow-md"
            data-testid="wave-logo"
          >
            <img
              src="/images/logo.png"
              alt="SympTrack, Powered by MyRelief"
              width="1536"
              height="864"
              className="h-auto w-[210px] md:w-[230px]"
            />
          </div>
          <p
            className="wave-slogan font-extrabold leading-[1.08]"
            data-testid="wave-slogan"
          >
            <span className="block text-white">Better understanding.</span>
            <span className="block text-brand-coral">Better tomorrows.</span>
          </p>
          <span
            aria-hidden="true"
            className="hidden h-[86px] w-px bg-white/25 md:block"
          />
          <a
            href="https://calendly.com/SympTrack"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="book-a-meeting-button"
            className="btn-coral primary-action h-[72px] px-8 text-[18px] md:h-[76px] md:px-9"
          >
            <CalendarDays aria-hidden="true" className="h-6 w-6" />
            Book a Meeting
            <ChevronRight aria-hidden="true" className="h-5 w-5" />
          </a>
        </div>
      </div>
    </section>
  );
}
